import { Tooltip } from "antd";
import { FC, ReactNode } from "react";
import { useClientTutorialStore } from "./client-tutorial.store";

interface ClientTutorialTipProps {
  text: string;
  children: ReactNode;
  placement?: "top" | "bottom" | "left" | "right" | "topLeft" | "topRight" | "bottomLeft" | "bottomRight";
}

export const ClientTutorialTip: FC<ClientTutorialTipProps> = ({
  text,
  children,
  placement = "top",
}) => {
  const tutorialMode = useClientTutorialStore((s) => s.tutorialMode);

  if (!tutorialMode) return <>{children}</>;

  return (
    <Tooltip
      title={text}
      placement={placement}
      color="#1e40af"
      overlayInnerStyle={{ fontSize: 13, maxWidth: 280 }}
      open={undefined}
    >
      <span className="tutorial-highlight rounded transition-colors hover:bg-blue-100 hover:ring-2 hover:ring-blue-300 hover:ring-offset-1">
        {children}
      </span>
    </Tooltip>
  );
};
